import { badArguments } from 'config/errors';
import { gather, set } from 'shared/set';
import { isString } from 'utils/is';

export default function blcktive$toggle(keypath, options) {
  if (!isString(keypath)) {
    throw new TypeError(badArguments);
  }

  return set(
    gather(this, keypath, null, options && options.isolated).map(m => [m, !m.get()]),
    options
  );
}
